import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { okrCascadeRouteRef } from './routes';

export const okrPlugin = createPlugin({
  id: 'okr-frontend',
  routes: {
    root: okrCascadeRouteRef,
  },
});

export const OkrCascadePage = okrPlugin.provide(
  createRoutableExtension({
    name: 'OkrCascadePage',
    component: () =>
      import('./components/OkrCascadePage/OkrCascadePage').then(
        m => m.OkrCascadePage,
      ),
    mountPoint: okrCascadeRouteRef,
  }),
);

export { EntityGroupOkrTab } from './components/EntityGroupOkrTab/EntityGroupOkrTab';
